/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetIntegrationsConfig200ResponseTehtrisTriggers } from './GetIntegrationsConfig200ResponseTehtrisTriggers';
import {
    GetIntegrationsConfig200ResponseTehtrisTriggersFromJSON,
    GetIntegrationsConfig200ResponseTehtrisTriggersFromJSONTyped,
    GetIntegrationsConfig200ResponseTehtrisTriggersToJSON,
    GetIntegrationsConfig200ResponseTehtrisTriggersToJSONTyped,
} from './GetIntegrationsConfig200ResponseTehtrisTriggers';

/**
 * 
 * @export
 * @interface GetIntegrationsConfig200ResponseTehtris
 */
export interface GetIntegrationsConfig200ResponseTehtris {
    /**
     * 
     */
    enabled: boolean;
    /**
     * 
     */
    hasApiKey: boolean;
    /**
     * 
     */
    customerName: string;
    /**
     * 
     */
    appliance: string;
    /**
     * 
     */
    region: GetIntegrationsConfig200ResponseTehtrisRegionEnum;
    /**
     * 
     */
    defaultStatusId: string;
    /**
     * 
     */
    triggers: GetIntegrationsConfig200ResponseTehtrisTriggers;
}


/**
 * @export
 */
export const GetIntegrationsConfig200ResponseTehtrisRegionEnum = {
    Xjc: 'xjc',
    Xjd: 'xjd',
    Xje: 'xje',
    Xjf: 'xjf',
    Xjg: 'xjg',
} as const;
export type GetIntegrationsConfig200ResponseTehtrisRegionEnum = typeof GetIntegrationsConfig200ResponseTehtrisRegionEnum[keyof typeof GetIntegrationsConfig200ResponseTehtrisRegionEnum];


/**
 * Check if a given object implements the GetIntegrationsConfig200ResponseTehtris interface.
 */
export function instanceOfGetIntegrationsConfig200ResponseTehtris(value: object): value is GetIntegrationsConfig200ResponseTehtris {
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    if (!('hasApiKey' in value) || value['hasApiKey'] === undefined) return false;
    if (!('customerName' in value) || value['customerName'] === undefined) return false;
    if (!('appliance' in value) || value['appliance'] === undefined) return false;
    if (!('region' in value) || value['region'] === undefined) return false;
    if (!('defaultStatusId' in value) || value['defaultStatusId'] === undefined) return false;
    if (!('triggers' in value) || value['triggers'] === undefined) return false;
    return true;
}

export function GetIntegrationsConfig200ResponseTehtrisFromJSON(json: any): GetIntegrationsConfig200ResponseTehtris {
    return GetIntegrationsConfig200ResponseTehtrisFromJSONTyped(json, false);
}

export function GetIntegrationsConfig200ResponseTehtrisFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetIntegrationsConfig200ResponseTehtris {
    if (json == null) {
        return json;
    }
    return {
        
        'enabled': json['enabled'],
        'hasApiKey': json['hasApiKey'],
        'customerName': json['customerName'],
        'appliance': json['appliance'],
        'region': json['region'],
        'defaultStatusId': json['defaultStatusId'],
        'triggers': GetIntegrationsConfig200ResponseTehtrisTriggersFromJSON(json['triggers']),
    };
}

export function GetIntegrationsConfig200ResponseTehtrisToJSON(json: any): GetIntegrationsConfig200ResponseTehtris {
    return GetIntegrationsConfig200ResponseTehtrisToJSONTyped(json, false);
}

export function GetIntegrationsConfig200ResponseTehtrisToJSONTyped(value?: GetIntegrationsConfig200ResponseTehtris | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'enabled': value['enabled'],
        'hasApiKey': value['hasApiKey'],
        'customerName': value['customerName'],
        'appliance': value['appliance'],
        'region': value['region'],
        'defaultStatusId': value['defaultStatusId'],
        'triggers': GetIntegrationsConfig200ResponseTehtrisTriggersToJSON(value['triggers']),
    };
}

